import React from 'react'

import { Text } from '@wartek-id/text-v1'

import { CONTENT_PERILAKU_KERJA } from 'app/KinerjaPSPegawaiPage/configs/content-perilaku-kerja'

function PanduanPerilakuKerja(_props: any) {
  return (
    <div className="px-8 pb-8 bg-gray-10 min-h-full">
      <div className="max-w-7xl mx-auto">
        <Text variant="display-md" className="text-black" as="h1">
          Perilaku Kerja: Indikator dan Perwujudan
        </Text>

        <div className="mt-12 bg-white rounded-lg">
          <div className="p-9">
            <div className="flex flex-col gap-10">
              {CONTENT_PERILAKU_KERJA.aspek.map((aspek, i) => {
                return (
                  <div
                    key={`aspek-${i}`}
                    className="border border-gray-30 rounded p-6"
                  >
                    <div className="flex flex-col gap-6">
                      <div className="flex gap-2.5 items-center">
                        <div className="flex items-center justify-center rounded-full bg-blue-70 w-6 h-6 p-3">
                          <div className="absolute flex">
                            <Text
                              color="inverse"
                              className="!font-bold !text-sm"
                            >
                              {i + 1}
                            </Text>
                          </div>
                        </div>
                        <Text variant="display-sm">{aspek.value}</Text>
                      </div>

                      {aspek.indikator.map((indikator, j) => {
                        return (
                          <div
                            className="border-b border-b-subdued pb-6 last:border-b-0 last:pb-0 flex flex-col gap-6"
                            key={`indikator-${j}`}
                          >
                            <div className="flex flex-col gap-0.5">
                              <Text color="subdued">Indikator</Text>
                              <Text>
                                {i + 1}.{j + 1} {indikator.value}
                              </Text>
                            </div>

                            <div className="flex flex-col gap-0.5">
                              <Text color="subdued">Perwujudan</Text>
                              {indikator.ekspektasi.map((ekspektasi, k) => [
                                <Text key={`perwujudan-${k}`}>
                                  {i + 1}.{j + 1}.{k + 1} {ekspektasi.value}
                                </Text>,
                              ])}
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function WrappedPanduanPerilakuKerja(_props: any) {
  return <PanduanPerilakuKerja />
}

export default WrappedPanduanPerilakuKerja
